import { render, staticRenderFns } from "./salinvoicechange.vue?vue&type=template&id=6c12f3e9&scoped=true&"
import script from "./salinvoicechange.vue?vue&type=script&lang=js&"
export * from "./salinvoicechange.vue?vue&type=script&lang=js&"
import style0 from "./salinvoicechange.vue?vue&type=style&index=0&id=6c12f3e9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c12f3e9",
  null
  
)

export default component.exports